<script>
	// @ts-nocheck
	import { createEventDispatcher } from 'svelte';
	import { onMount } from 'svelte';
	import { currentUser } from '../utils/utils.js';
	import { getStatus, getGridList, runModeling } from '../utils/api.js';
	import {
		notifications,
		NotificationDisplay,
		LogoLoader,
		TableView,
		StatusLight,
		Tooltip
	} from '@shopboxai/sb-portal-components';
	export let user = null;
	let loading = false;
	let mounted = false;
	let appStatus, gridList;
	const dispatch = createEventDispatcher();

	const redirect = () => {
		dispatch('redirect', '/help');
	};

	const gridStatus = async (id) => {
		let status = await getStatus($currentUser.fullClientId, $currentUser.accessToken, id);
		return status.live;
	};

	const modeling = async () => {
		try {
			loading = true;
			let res = await runModeling($currentUser.fullClientId, $currentUser.accessToken);
			loading = false;
			if (res.status == 'QUEUED') {
				notifications.success(
					'Request successful, modelling will begin shortly. This could take a few hours depending on your product catalogue size.',
					4000
				);
			}
			if (res.status == 'IN_PROGRESS') {
				notifications.info('Modelling in progress', 2000);
			}
			if (res.status == 'COMPLETE') {
				var time = new Date(res.wait * 1000).toISOString().substring(11, 16);
				notifications.warning(
					`Modelling requests can be done only once every 5h, please try again in ${time} hours.`,
					6000
				);
			}
			if (res.status == 'FAILED') {
				notifications.danger(
					'Something went wrong. Please contact us using our <a href="/help">Help app</a>',
					10000
				);
			}
		} catch (error) {
			notifications.danger(
				'Something went wrong. Please contact us using our <a href="/help">Help app</a>',
				6000
			);
		}
	};
	onMount(async () => {
		if (user) {
			$currentUser = user;
			appStatus = await getStatus($currentUser.fullClientId, $currentUser.accessToken);
			appStatus = appStatus.live;
			gridList = await getGridList($currentUser.fullClientId, $currentUser.accessToken);
		}
		mounted = true;
	});
</script>

{#if mounted}
	<div class="app-container">
		<h1>Go Live</h1>
		<TableView tableActionName="Request help" on:tableAction={redirect}>
			<thead slot="thead">
				<tr>
					<th>Name</th>
					<th>Product</th>
					<th>Status</th>
					<th />
				</tr>
			</thead>
			<tbody slot="tbody">
				<tr>
					<td>Shopbox Widget</td>
					<td>Shopbox Widget</td>
					<td>
						<Tooltip
							tip="Shopbox widget will be marked as inactive if it is either disabled on the site or not embedded correctly."
						>
							<StatusLight state={appStatus} />
						</Tooltip>
					</td>
					{#if appStatus}
						<td class="right"
							><button on:click={modeling}>{loading ? 'Loading..' : 'Run modeling'}</button></td
						>
					{:else}
						<td />
					{/if}
				</tr>

				{#if Array.isArray(gridList)}
					{#each gridList as grid}
						{#if grid.name}
							<tr>
								<td><span>{grid.name}</span></td>
								<td>Shopbox Grid</td>
								{#await gridStatus(grid.id)}
									<td>Loading..</td>
									<td />
								{:then value}
									<td>
										<Tooltip
											tip="Grids which have no user activity in the last 72 hours are marked as Inactive"
										>
											<StatusLight state={value} />
										</Tooltip>
									</td>

									<td />
								{:catch error}
									<td />
								{/await}
							</tr>
						{/if}
					{/each}
				{/if}
			</tbody>
		</TableView>

		<NotificationDisplay />
	</div>
{:else}
	<div class="loader">
		<LogoLoader />
	</div>
{/if}

<style>
	:global(*) {
		box-sizing: border-box;
		margin: 0;
	}
	:global(html, body) {
		width: 100%;
		height: 100%;
		font-family: 'Overpass', sans-serif;
	}
	h1 {
		font-family: 'Chivo', serif;
		margin-bottom: 1em;
	}
	a,
	button {
		text-decoration: underline !important;
		color: var(--l-c);
		font-size: 0.9em;
	}
	.loader {
		position: absolute;
		top: 400px;
		left: 50%;
		transform: translateX(-50%) scale(2);
	}
</style>
